/* eslint-disable no-console */
import VTextField from 'vuetify/lib/components/VTextField/VTextField';

const IntEditor = VTextField.extend({
  created () {
    if (this.value || this.value == 0) this.internalValue = parseInt(this.value)
  },
  methods: {
    onKeyDown (e) {
      let code = e.keyCode;
      if (code == 13) {
        let value = e.target.value;
        if (value || value === 0 || value === '0') {
          value = parseInt(value);
          this.internalValue = value;
        }
        e && this.$emit('change', value);
        return;
      }
      let value = e.target.value, pos = e.target.selectionStart;
      let b1 = (e.ctrlKey || e.metaKey) && (code == 67 || code == 86 || code == 88 || code == 65); // Ctrl/Command+[c、v、x、a]
      let b2 = (code >= 48 && code <= 57) || (code >= 96 && code <= 105) || code == 189; // 0-9,小键盘0-9，-
      let b3 = code >= 37 && code <= 40; // 左上右下
      let b4 = code == 8 || code == 9 || code == 16; // 回退、tab、Shift
      let minusIdx = value.indexOf('-');
      if ((!b1 && !b2 && !b3 && !b4) || (code == 189 && (pos != 0 || minusIdx != -1))) {
        e.returnValue = false;
      } else {
        this.$emit('keydown', e);
      }
    },
    onBlur (e) {
      let value = e.target.value;
      if (value || value === 0 || value === '0') {
        value = parseInt(value);
        this.internalValue = value;
      }
      this.isFocused = false;
      e && this.$nextTick(() => this.$emit('blur', e));
    }
  }
})

export default {
  install: function (Vue) {
    Vue.component('int-editor', IntEditor)
  }
}